/* eslint-disable no-shadow */
import { useState, useEffect, useRef } from 'react'
import useFetch from 'react-fetch-hook'
import { useReactiveVar } from '@apollo/client'
import { BASE_PATH } from '../../../../config/connections'
import {
  payeeDashbord,
  RestAPICache,
  searchedBillerDetails,
  selectedBillerDetails,
  userAccount
} from '../../../../graphql/cache/localCache'
import { appCache, aemContentCache } from '../../../../context/appCache'
import { useSearchDashboadService } from '../../../../service/payees/add/dashboard.service'
import DashboardSearchBills from '../../../../modules/payees/add/dashboard/search-bills/search-bills'
import DashboardFindBillsModal from '../../../../modules/payees/add/dashboard/find-bills-modal/find-bills'
import DashboardFindAddBills from '../../../../modules/payees/add/dashboard/find-add-bills/find-add-bills'
import DashboardHeader from '../../../../modules/payees/add/dashboard/header/dashboard-header'
import routerpath from '../../../../constants/routerpath'
import {
  configureNativeHeader,
  NativeInterfaceHandler
} from '../../../../utils/nativeHandlers'
import { isTuxApp, navigateRoute } from '../../../../utils/browserutils'
import { serachPayloadData } from '../../../../utils/processData'
import ErrorComponent from '../../error'
import { getSessionStorageValue } from '../../../../utils/sessionUtils'
import { PageviewTealiumEvent } from '../../../../utils/tealiumwrapper'
import { PAGE_NAMES } from '../../../../constants/tealiumData'
import { routeController } from '../../../../router/routeController'
import { ProductCode } from '../../../../utils/verifyBills'
import SearchFindPopup from '../../../../modules/payees/add/dashboard/searchFindPopUp'
import { useMultilingualService } from '../../../../service/multilingualService'
import DisclaimerService, {
  aemContentFormattedData
} from '../../../../service/payees/aem/disclaimerService'
import DisclaimerModal from '../../../../modules/payees/add/dashboard/find-bills-modal/disclaimerModal'
import { accessDeniedErrorCodes } from '../../../../utils/errorMapping'
import AccessDeniedPopUP from '../../../../modules/payees/search/access_denied/AccessDeniedPopUP'
import { getGraphQLAPIErrorCode } from '../../../../utils/servicesUtils'
import MobileBillPayLayout from '../../../../modules/layout/MobileBillPayLayout'
import AddBillError from '../../../../components/addbillModal/AddBillModal'

/**
 * Add bill Dashboard
 *
 *
 * @returns {HTMLElement}
 */
const Dashboard = () => {
  const [minchar] = useState(3)
  const [searchVal, setSearchVal] = useState('')
  const [selBill, setSelBill] = useState({})
  const [selPopUp, setSelPopUp] = useState('')
  const [accessDeniedModal, setaccessDeniedModal] = useState(false)
  const [reviewModal, setReviewModal] = useState({})
  const [payeeList, setPayeeList] = useState([])
  const [subText, setSubText] = useState('')
  const [findBillsModal, setFindBillsModal] = useState(false)
  const [findBillsTerms, setFindBillsTerms] = useState(false)
  const [findBillsTermsError, setFindBillsTermsError] = useState(false)
  const [billDiscoveryEligible, setBillDiscoveryEligible] = useState(false)
  const [billDiscoveryConsentGiven, setBillDiscoveryConsentGiven] =
    useState(false)
  const [isOpenDisclaimerModal, setIsOpenDisclaimerModal] = useState(false)
  const [userInfoModal, showUserInfoModal] = useState(false)
  const [showError, setShowError] = useState(false)
  const [errorCode, setErrorCode] = useState('')

  const { data: aemData } = useFetch(DisclaimerService.getDisclaimerContent())

  const { aemFormattedData = {} } = useReactiveVar(aemContentCache)
  const { SEARCH_FIND, USER_INFO_MISSING_POPUP } =
    useMultilingualService('addBillSearch')

  const billpayDeepLinkNew = getSessionStorageValue('billpayDeepLinkNew')
  const {
    navTo = null,
    accountId = null,
    isSafeDebit,
    payeeData,
    isRestAPI = false,
    isScheduled = false,
    isAutopayment = false,
    payeeExist = false,
    isBillDiscoveryConsentGiven = false,
    isBillDiscoveryEligible = false,
    payeeListData,
    billerLogoUrl
  } = (billpayDeepLinkNew && JSON.parse(billpayDeepLinkNew)) || {}
  const autocompleteRef = useRef()

  const {
    loadApi,
    loading,
    error,
    searchBillData,
    data: searchBillDataResp
  } = useSearchDashboadService(isRestAPI)
  const { navigateRoutePath } = navigateRoute()
  const { channel } = appCache()

  const handleAnchorClick = () => {
    setIsOpenDisclaimerModal(true)
  }
  useEffect(() => {
    delete sessionStorage.onboardingBillpayDeeplink
    delete sessionStorage.fromOnboarding
  }, [])

  useEffect(() => {
    const formattedData = aemContentFormattedData(aemData)
    aemContentCache({ aemFormattedData: formattedData })
  }, [aemData])

  useEffect(() => {
    payeeDashbord({ isDashboard: true })
  }, [payeeDashbord])

  /**
   *add your template area alignment here
   */

  const handleSearchKeyPress = (val) => {
    loadApi({
      variables: serachPayloadData(isRestAPI, val)
    })
  }
  useEffect(() => {
    /* eslint-disable no-console */
    console.log(
      isScheduled,
      isAutopayment,
      payeeExist,
      payeeListData,
      'edit bill##'
    )
    if (navTo) {
      switch (navTo) {
        case '/payeedashboard':
          document.title = 'Pay bills'
          appCache({ ...appCache(), Title: 'Pay bills' })
          setBillDiscoveryEligible(isBillDiscoveryEligible)
          setBillDiscoveryConsentGiven(isBillDiscoveryConsentGiven)
          setPayeeList(payeeListData)
          selectedBillerDetails({
            selectedBill: { payeeData: payeeListData, payeeExist }
          })
          break
        case '/edit':
          appCache({ ...appCache(), Title: 'Edit bill' })
          selectedBillerDetails({
            selectedBill: {
              payeeId: accountId,
              isScheduled,
              isAutopayment,
              aggregateBillPayee: payeeData,
              payeeExist,
              billerLogoUrl
            }
          })
          break
        default:
          appCache({ ...appCache(), Title: 'Pay bills' })
          selectedBillerDetails({
            selectedBill: {
              payeeExist
            }
          })
      }

      userAccount({ isSafeDebit })
      RestAPICache({ isRestAPI })

      if (navTo === '/edit') {
        navigateRoutePath(`${BASE_PATH}${navTo}`)
      }
    } else {
      document.title = 'Pay bills'
      appCache({ ...appCache(), Title: 'Pay bills' })
    }

    if (navTo !== '/edit') {
      PageviewTealiumEvent(PAGE_NAMES.ADD_BILL_HOME)
    }
  }, [])
  const { selectedBill = {} } = selectedBillerDetails() || {}

  const { payeeExist: isBillerExist = false } = selectedBill

  useEffect(() => {
    configureNativeHeader(
      'findabilldashboard',
      isBillerExist,
      BASE_PATH + routerpath.pages.payeedashboard,
      routerpath.pages.openbillpay
    )
  }, [isBillerExist])

  useEffect(() => {
    if (searchVal.length === 0) {
      setSearchVal('')
      setSubText('')
    }
    if (searchVal && searchVal.length >= minchar) {
      const intiVal = searchVal.substr(0, minchar)

      if (intiVal !== subText) {
        // setLoading(true)
        handleSearchKeyPress(searchVal)
        setSubText(intiVal)
      }
    }
  }, [searchVal, handleSearchKeyPress, minchar, subText])
  const redirectAddBillInfoSearch = (item) => {
    setSelBill(item)
    const input = document.querySelector(
      '#add-bill-dashboard-search-input1 > input'
    )
    input?.blur()
    setSelPopUp('searchBillConfirm')
    const cURI = item ? item.billerSiteUrl : ''
    const dashboardData = selectedBill?.payeeData || payeeList

    const isSelBillDashboard =
      dashboardData &&
      dashboardData.some(
        (el) => el?.billPayPayee?.biller?.merchantAlias === cURI
      )
    const name = item?.billerName?.toLowerCase?.()
    const dataList =
      dashboardData &&
      dashboardData.filter((el) => {
        if (el?.billPayPayee?.isPayeeInternal) {
          if (name === 'us bank credit card') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_CCD ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_BCD ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_EXL
            )
          }
          if (name === 'us bank loans') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_BLN ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_SLN ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_UNL
            )
          }
          if (name === 'us bank lease') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_LEA
            )
          }
          if (name === 'us bank lineofcredit') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
              ProductCode.PRODUCTCODE_LOC
            )
          }
          if (name === 'us bank mortgage') {
            return (
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_ADP ||
              el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode ===
                ProductCode.PRODUCTCODE_MAL
            )
          }
          if (name === 'us bank') {
            return (
              el && el?.billPayPayee?.payee?.payeeAccountInfo[0]?.productCode
            )
          }
        }
        return false
      })

    if (isSelBillDashboard || (dataList && dataList.length > 0)) {
      NativeInterfaceHandler('PopUpHandler', true)
      const input = document.querySelector(
        '#add-bill-dashboard-search-input1 > input'
      )
      input?.blur()
      setReviewModal({ openReviewModal: true })
    } else {
      navigateRoutePath(`${BASE_PATH}${routerpath.pages.search}`)
    }
  }
  const setTypeaheadVal = (event) => {
    const selBillList =
      searchBillData && searchBillData.filter((el) => el.id === event.id)
    const pURI =
      selBillList && selBillList?.length > 0 ? selBillList[0].billerSiteUrl : ''
    const selTypeAheadBillList =
      searchBillDataResp &&
      searchBillDataResp?.billpayPayeeListInquiry &&
      searchBillDataResp?.billpayPayeeListInquiry?.billerList?.filter(
        (item) =>
          (item && item.billerSiteUrl ? item.billerSiteUrl : '') === pURI
      )
    const logoURL =
      selTypeAheadBillList && selTypeAheadBillList?.length > 0
        ? selTypeAheadBillList[0].billerLogoUrl
        : ''
    searchedBillerDetails({
      billerName: event.value,
      billerZipRequired: event.billerZipRequired,
      billerSiteUrl: event.billerSiteUrl,
      billerLogoUrl: logoURL
    })

    redirectAddBillInfoSearch(
      (selTypeAheadBillList && selTypeAheadBillList[0]) || {}
    )
  }

  const onAddbillManually = () => {
    navigateRoutePath(`${BASE_PATH}${routerpath.pages.manual}`)
  }
  const redirectToDashboard = () => {
    const sharedData = {
      currentPath: '/',
      channel: 'OLB',
      AppFlow: 'OPENBILLPAY',
      AppError: false,
      ReturnURL: '',
      successMsg: null,
      payeeId: null,
      navTo: routerpath.pages.home
    }
    delete sessionStorage.billpayDeepLinkNew
    routeController(sharedData)
  }

  const onContinue = () => {
    if (!findBillsTerms) {
      setFindBillsTermsError(true)
    } else {
      setFindBillsTermsError(false)
      setFindBillsModal(false)
      navigateRoutePath(`${BASE_PATH}${routerpath.pages.findbills}`)
    }
  }

  const onClose = () => {
    setFindBillsModal(false)
  }
  const closePopup = () => {
    setaccessDeniedModal(false)
    NativeInterfaceHandler('PopUpHandler', false)
  }
  const makeHelplineCall = () => {
    setaccessDeniedModal(false)
    NativeInterfaceHandler('PopUpHandler', false)
    window.open('tel:8009877237', '_self')
  }

  useEffect(() => {
    const errorcode = error && getGraphQLAPIErrorCode(error)

    console.log({ errorcode })
    if (error && accessDeniedErrorCodes?.includes(errorcode)) {
      setaccessDeniedModal(true)
      NativeInterfaceHandler('PopUpHandler', true)
    } else if (errorcode === '409.1800.2806') {
      setErrorCode(errorcode)
      showUserInfoModal(true)
    } else {
      // eslint-disable-next-line no-lonely-if
      if (error) setShowError(true)
    }
  }, [error])

  return (
    <>
      {/* <Helmet>
        <title>Pay bills</title>
      </Helmet> */}
      {/* <Layout.PaddingColumns> */}
      {!showError && (
        <>
          {isTuxApp() && <MobileBillPayLayout />}
          <DashboardHeader
            {...{
              // onAddbillManually,
              // headerStyles,
              // addBillStyles,
              redirectToDashboard,
              channel
            }}
          />
          <DashboardSearchBills
            {...{
              setSearchVal,
              searchBillData,
              setTypeaheadVal,
              loading,
              autocompleteRef
            }}
          />

          <DashboardFindAddBills
            {...{
              setFindBillsModal,
              isBillerExist,
              billDiscoveryConsentGiven,
              onAddbillManually,
              setSearchVal,
              searchBillData,
              setTypeaheadVal,
              loading,
              billDiscoveryEligible
            }}
          />
          {/* <div style={{ marginBottom: isOLBOrIpadApp() ? '' : '2.56rem' }}>
              <DashboardAddManually
                {...{
                  onAddbillManually,
                  setSearchVal,
                  searchBillData,
                  setTypeaheadVal,
                  loading,
                  isBillerExist
                }}
              />
            </div> */}
          {!isOpenDisclaimerModal ? (
            <DashboardFindBillsModal
              {...{
                findBillsModal,
                findBillsTerms,
                setFindBillsTerms,
                findBillsTermsError,
                handleAnchorClick,
                onContinue,
                onClose
              }}
            />
          ) : (
            <DisclaimerModal
              displayName=""
              isOpenDisclaimerModal={isOpenDisclaimerModal}
              disclaimer={aemFormattedData}
              handleClick={() => {
                setIsOpenDisclaimerModal(false)
              }}
            />
          )}

          {/* <DashboardNearbyMarchants
              {...{ paymybillImg, channel, widthStyle }}
            />
            <DashboardOtherCompany {...{ paymybillImg }} /> */}
        </>
      )}

      {reviewModal && reviewModal?.openReviewModal === true && (
        <SearchFindPopup
          {...{
            selBill,
            selPopUp,
            reviewModal,
            autocompleteRef,
            payeeData: selectedBill?.payeeData,
            setReviewModal,
            lang: SEARCH_FIND
          }}
        />
      )}
      {showError && !accessDeniedModal && <ErrorComponent />}
      {error && accessDeniedModal && (
        <AccessDeniedPopUP
          closePopup={closePopup}
          openModal={accessDeniedModal}
          callhelpline={makeHelplineCall}
        />
      )}
      {userInfoModal && (
        <AddBillError
          handleModalClose={() => showUserInfoModal(false)}
          lang={USER_INFO_MISSING_POPUP}
          errorCode={errorCode}
        />
      )}
    </>
  )
}

export default Dashboard
